export default "__VITE_ASSET__Gk5an5FV__"